<template>
  <div class="the-navbar__user-meta flex items-center" v-if="user.me">

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="flex items-center">
        <div class="text-right leading-tight hidden sm:block">
          <p class="font-semibold">
            {{ user.me.name.split(' ').slice(0,2).join(' ').trim() }}
          </p>
        </div>

        <div class="con-img ml-3" id="work-pace-list">
          <vs-avatar
            color="danger"
            slot="avatar"
            :text="selectedCompany.name.split(' ').slice(0,2).join(' ').trim()"
          />
        </div>
      </div>

      <!-- Dropdown Menu -->
      <vs-dropdown-menu class="vx-navbar-dropdown company-dropdown">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 text-center">
            <span class="ml-2 text-primary text-center">
              Carpetas de trabajo
            </span>
          </li>

          <li
            v-for="company in owned_companies"
            :key="company.id"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center"
            @click="changeCompany(company, 'owner')"
          >
            <vs-avatar
              color="danger"
              slot="avatar"
              class="con-vs-avatar-list"
              :text="company.name.split(' ').slice(0,2).join(' ').trim()"
            />
            <span class="ml-2 my-auto">
              {{ company.name.trim() }}
            </span>
            <feather-icon icon="ShieldIcon" svgClasses="w-4 h-4 ml-auto" title="Propietario" />
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4">
            <span class="ml-2 text-primary text-center">
              Carpetas de trabajo invitados
            </span>
          </li>

          <li
            v-for="company in invited_companies"
            :key="company.id"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center"
            @click="changeCompany(company, company.role)"
          >
            <vs-avatar
              color="warning"
              slot="avatar"
              class="con-vs-avatar-list"
              :text="company.name.split(' ').slice(0,2).join(' ').trim()"
            />
            <span class="d-block w-100 ml-2">
              {{ company.name.trim() }}
            </span>
            <feather-icon :icon="company.role === 'operator' ? 'UserCheckIcon' : 'EyeIcon'" svgClasses="w-4 h-4 ml-auto" :title="roles[company.role]" />
            <small class="ml-2">
              {{ roles[company.role] }}
            </small>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Administrar Carpetas de trabajo</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <!-- Enlace para salir -->
    <router-link tabindex="-1" to="/login">
      <div class="text-right leading-tight hidden sm:block">
        <p class="pl-2">Salir</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import {mapState} from "vuex";
export default {
  data() {
    return {
      roles: {
        invited: "Invitado",
        operator: "Operador"
      }
    }
  },
  computed: {
    ...mapState({
      user: function (state) {
        return state.account.user;
      },
      selectedCompany() {
        return this.$store.state.account.user.me.selected_company;
      },
      owned_companies: function (state) {
        return state.account.user.me.owned_companies;
      },
      invited_companies: function (state) {
        return state.account.user.me.invited_companies;
      }
    }),
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
        this.$router.push('/configuration/work-folders').catch(() => {})
    },
    changeCompany(company, role) {
      this.$store.dispatch("account/changeCompany", { company, role });
    }
  }
}
</script>
